export default "__VITE_ASSET__C7y1JCMQ__"